import { render } from "./FormFieldCollection.vue?vue&type=template&id=5dd56d40&scoped=true"
import script from "./FormFieldCollection.vue?vue&type=script&lang=js"
export * from "./FormFieldCollection.vue?vue&type=script&lang=js"

import "./FormFieldCollection.vue?vue&type=style&index=0&id=5dd56d40&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd56d40"]])

export default __exports__